module.exports = {"230302001":"向阳街道","230302002":"南山街道","230302003":"立新街道","230302004":"东风街道","230302005":"红军路街道","230302006":"西鸡西街道","230302007":"西山街道","230302200":"红星乡","230302201":"西郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230302.json
// module id = 649
// module chunks = 0